import React from "react";

import ModalOrBottomSheetWrapper from "@vahak/core-ui/dist/components/ModalOrBottomSheetWrapper";

import AppImg from "../../utils/AppImg";
import { getVehicleRestrictionPopupConfig } from "./getVehicleRestrictionPopupConfig";
import { VehicleRestrictionKind } from "./types";
import Styles from "./VehicleRestrictionPopup.module.scss";

interface VehicleRestrictionPopupProps {
    isOpen: boolean;
    kind: VehicleRestrictionKind;
    onCancel: () => void;
    onPrimary: (e?: React.MouseEvent) => void;
    id?: string;
    primaryLabelOverride?: string;
    capacityRangeLabel?: string;
}

const VehicleRestrictionPopup = ({
    isOpen,
    kind,
    onCancel,
    onPrimary,
    id = "vehicle-restriction-popup",
    primaryLabelOverride,
    capacityRangeLabel
}: VehicleRestrictionPopupProps) => {
    const config = getVehicleRestrictionPopupConfig(kind, { capacityRangeLabel });
    const primaryLabel = primaryLabelOverride || config.primaryLabel;

    return (
        <ModalOrBottomSheetWrapper
            id={id}
            isOpen={isOpen}
            onToggle={onCancel}
            showHeader={false}
            modalSize="fit"
            borderRadius={25}
            sheetBorderRadius={25}
            paddedModal={false}
            paddedSheet={false}
            showBottomSheetOverlay
            blurBackground
            disableSheetSwipe
            // Nested over load/lorry posting modals — avoid overlay/esc dismissing the parent form.
            modalShouldCloseOnOverlayClick={false}
            modalShouldCloseOnEsc={false}
            disableSheetOverlayClick
        >
            <div className={Styles.content}>
                <div className={Styles.bannerWrap}>
                    <AppImg
                        className={Styles.banner}
                        src={config.bannerSrc}
                        alt=""
                        width={167}
                        height={115}
                        aria-hidden
                    />
                </div>
                <div className={Styles.body}>
                    <h2 className={Styles.title}>{config.title}</h2>
                    <p className={Styles.description}>{config.description}</p>
                </div>
                <div className={Styles.actions}>
                    <button
                        type="button"
                        className={`${Styles.actionBtn} ${Styles.cancelBtn}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            onCancel();
                        }}
                    >
                        {config.cancelLabel}
                    </button>
                    <button
                        type="button"
                        className={`${Styles.actionBtn} ${Styles.primaryBtn}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            onPrimary(e);
                        }}
                    >
                        {primaryLabel}
                    </button>
                </div>
            </div>
        </ModalOrBottomSheetWrapper>
    );
};

export default VehicleRestrictionPopup;
